import fr from '@/translations/fr.json';
import en from '@/translations/en.json';
import { createI18n } from 'vue-i18n';

const i18n = createI18n({
    legacy: false,
    locale: 'fr_Fr',
    fallbackLocale: 'fr_Fr',
    allowComposition: true,
    messages: {
        fr_Fr: fr,
        en_En: en,
    },
});

const { t } = i18n.global;

export { t };

export { i18n };
